import { request } from './request';
import config from 'root/common/config/config';
import appId from './appId';

/**
 * 优惠券礼包banner
 */
export function couponBanner(params) {
    return request({
        url: config.api.shopCouponBanner,
        headers: {
            appId,
        },
        method: 'GET',
        isNeedToken: false,
        params,
    });
}

/**
 * 获取优惠券领取列表
 */
export function couponActiveIndex(data) {
    return request({
        url: config.api.shopCouponActiveIndex,
        headers: {
            appId,
        },
        method: 'POST',
        data: data,
    });
}

/**
 * 优惠券领取
 */
export function couponReceive(data) {
    return request({
        url: config.api.shopCouponReceive,
        headers: {
            appId,
        },
        method: 'POST',
        data: data,
    });
}

/**
 * 支付成功后获取优惠券金额
 */
export function queryPackageAmount(params) {
    return request({
        url: config.api.queryPackageAmount,
        method: 'GET',
        params,
    });
}

/**
 * 支付成功后领取优惠券
 */
export function receiveByPaySuccess(data) {
    return request({
        url: config.api.receiveByPaySuccess,
        headers: {
            appId,
        },
        method: 'POST',
        data: data,
    });
}
/**
 * 优惠券一键领取
 */
export function receiveCouponByPackage(data) {
    return request({
        url: config.api.receiveCouponByPackage,
        headers: {
            appId,
        },
        method: 'POST',
        data: data,
    });
}

// 领取优惠券
export function cardCouponReceive(params) {
    return request({
        url: config.api.cardCouponReceive,
        params,
        isNeedToken: true,
    });
}

/**
 * 整合java和php的领取接口，根据type参数来决定使用哪个接口
 * @param {*} param0
 * @param {string} param0.type 优惠券类型
 */
export function receiceCoupon({ couponId, type, ...args }) {
    const typeList = ['recharge', 'ticket', 'movie'];
    if (typeList.includes(type))
        return cardCouponReceive({ couponId, type, ...args }).then(res => {
            if (res.code == 0) res.code = 200; // 统一错误码
            return res;
        });
    else return couponReceive({ couponId, ...args });
}
